/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react'
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import ReactHTMLParser from 'react-html-parser';
import { makeStyles } from '@material-ui/core/styles';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { icons } from './assets/icons';

const useStyles = makeStyles((theme) => ({
   recipientLandingErrorContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '6rem 3.5rem 3.5rem 3.5rem',
      '& a': {
         backgroundColor: theme.palette.thankyoucards.primaryColor,
         color: `${theme.palette.common.white} !important`,
         borderRadius: '3px !important',
         padding: theme.spacing(1, 3),
         marginRight: '0 !important',
         border: 'none !important',
         textDecoration: 'none',
         '&:hover': {
            backgroundColor: '#482a75 !important',
         },
      },
   },
   letterIcon: {
     fontSize: 80,
     color: theme.palette.primary.main,
     height: '68px!important',
     width: '99px!important'
   },
   sorryText: {
      fontFamily: 'Lato',
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '26px',
      marginTop: '26px',
      letterSpacing: '0.01em',
      textAlign: 'center',
      marginBottom: '0px',
   },
   link: {
      width: '157px', 
      height: '36px', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      fontWeight: 'bold',
      marginTop: '24px',
   }
 }));

const RecipientLandingErrorPage = ({ cardIsleParams }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const sorryText = cardIsleParams ? 'Sorry, we can’t find your message at this time.' : 'Sorry, we can’t find your message at this time. Please double-check your last 6 digit tracking number you entered and ensure that it is correct.';
  const formattedSorryText = sorryText.split(',').join(', <br/>');

  return (
   <Grid container className={classes.recipientLandingErrorContainer}>
      <Grid item>
         {icons.redEnvelope}
      </Grid>
      <p className={classes.sorryText}>{ReactHTMLParser(formattedSorryText)}</p>
      <Link className={classes.link} onClick={() => dispatch(EventDispatcher.clearRecipientVerifyData())} to={cardIsleParams ? `/account/thankyoucards/${cardIsleParams}` : '/account/thankyoucards'}>TRY AGAIN</Link>
   </Grid>
  )
}

export default RecipientLandingErrorPage;